"use strict";

angular.module("core").controller("MinimumVersionController", function($scope, IS_MOBILE_APP) {
    $scope.isMobileApp = IS_MOBILE_APP;

    this.reloadPage = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        location.reload(true);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/minimum-version/minimum-version.modal.js
// module id = 452
// module chunks = 0